(function () {
    'use strict';

    angular.module("imApp").factory("discGrpCustLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listLanguages: function (parms) {
                return $ihttp.post({
                    method: 3121,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3122,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
